<template>
  <div id="resetPassword" class="login">
    <!-- Fake input to prevent saved password to be filled -->
    <input id="fakeEmail" type="email" class="d-none">
    <input id="fakePassword" type="password" class="d-none">

    <div class="login-card row">
      <div class="login-card-logo col-md-7">
        <img v-img-fallback="{ loading: imgBaseUrl + 'pixel.png', error: imgBaseUrl + 'kerlink-light.png' }" :src="imgBaseUrl + 'logo/logo-light.png'" alt="Logo">

        <h4 class="mt-4 text-secondary text-center text-uppercase font-weight-bold">Wanesy Management Center</h4>
      </div>

      <div v-if="expired" class="login-card-form col-md-5">
        <div class="text-white text-center">
          <p>{{ $t('resetPassword:linkExpiredError') | capitalize }}</p>
          <p>{{ $t('resetPassword:askNewLink') | capitalize }}</p>
        </div>
        <router-link id="goToLoginLink" to="/login" class="btn btn-secondary btn-block">{{ $t('resetPassword:back') | capitalize }}</router-link>
      </div>

      <div v-else class="login-card-form col-md-5">
        <div class="form-group position-relative">
          <label class="control-label text-white" for="password">{{ $t('resetPassword:newPassword') | capitalize }} *</label>
          <input id="password"
                 ref="password"
                 v-model="password"
                 v-validate="'required'"
                 :class="{ 'is-invalid': errors.has('password') }"
                 :placeholder="$t('resetPassword:newPassword') | capitalize"
                 :data-vv-as="$t('resetPassword:password')"
                 type="password"
                 class="form-control"
                 name="password"
                 @keyup="checkCapslock"
          >
          <password-strength :password="password" />
        </div>

        <div class="form-group">
          <label class="control-label text-white" for="rePassword">{{ $t('resetPassword:rePassword') | capitalize }} *</label>
          <input id="rePassword"
                 v-model="rePassword"
                 v-validate="'required|confirmed:password'"
                 :class="{ 'is-invalid': errors.has('rePassword') }"
                 :placeholder="$t('resetPassword:rePassword') | capitalize"
                 :data-vv-as="$t('resetPassword:password')"
                 type="password"
                 name="rePassword"
                 class="form-control"
                 @keyup.exact="checkCapslock"
                 @keyup.enter="changePassword"
          >
        </div>

        <div v-show="isCapsLock" class="caps-lock">{{ $t('resetPassword:capsLock') | capitalize }}</div>
        <div v-show="errors.has('rePassword')" class="alert alert-danger" role="alert">{{ errors.first('rePassword') | capitalize }}</div>
        <div v-show="error === 5" class="alert alert-danger" role="alert">{{ $t('resetPassword:expiredError', {user: username}) | capitalize }}</div>
        <div v-show="error === 6" class="alert alert-danger" role="alert">{{ $t('resetPassword:disabledError', {user: username}) | capitalize }}</div>
        <div v-show="error === 7" class="alert alert-danger" role="alert">{{ $t('resetPassword:noValidatedError', {user: username}) | capitalize }}</div>
        <div v-show="error === 8" class="alert alert-danger" role="alert">{{ $t('passwordStrength:weakPassword') | capitalize }}</div>
        <div v-show="error === 0" class="alert alert-danger" role="alert">{{ $t('resetPassword:unknownError') | capitalize }}</div>

        <button id="changeButton" type="button" class="btn btn-secondary btn-block" @click="changePassword">{{ $t('resetPassword:change') | capitalize }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { last } from 'lodash-es'
import to from '@/modules/await-to-js'

export default {
  titleKey: 'resetPassword',

  data () {
    return {
      expired: false,
      password: '',
      rePassword: '',
      isCapsLock: false,
      username: '',
      error: null
    }
  },

  created () {
    // Check link validity
    const expiredDate = parseInt(last(location.hash.split('=')))
    this.expired = this.expired || (expiredDate < Date.now())
  },

  methods: {
    // Call API
    async changePassword () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      const token = last(location.hash.split('&')[0].split('='))

      let error, response
      [error, response] = await to(this.$api.resetPassword(this.$store.getters.application, this.password, token))

      if (error || !response) {
        if (error.response.status === 401) {
          this.expired = true
          return
        }

        switch (error.response.data.code) {
          case 'SECURITY_USER_EXPIRED':
            this.username = error.response.data.params[0]
            this.error = 5
            break
          case 'SECURITY_USER_DISABLED':
            this.username = error.response.data.params[0]
            this.error = 6
            break
          case 'SECURITY_USER_NOT_VALIDATED':
            this.username = error.response.data.params[0]
            this.error = 7
            break
          case 'WEAK_PASSWORD':
            this.error = 8
            break
          default:
            this.error = 0
        }
        return
      }

      this.username = ''
      this.error = -1 // ok
      this.$api.saveToken(response)
      this.$router.push('/')
    },

    // Check caps-lock status
    checkCapslock (event) {
      this.isCapsLock = event.getModifierState('CapsLock')
    }
  }
}
</script>
